<template>
    <div class="commondtitle">
        <div class="c_content">
            {{ title }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "commondtitle",
        props:['title'],
    }
</script>

<style scoped>
.commondtitle{
    width: 100%;
    height: 40px;
    padding-top: 40px;
    padding-bottom: 70px;
}
.c_content{
    position: relative;
    width: 1100px;
    margin: 0 auto;
    font-family: 微软雅黑;
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    color: #333;
}
.c_content::before,
.c_content::after{
    content: '';
    position: absolute;
    top: 20px;
    width: 440px;
    height: 1px;
    background-color: #333;
}
.c_content::before{
    left: 0;
}
.c_content::after{
    right: 0;
}
</style>